module.exports = __webpack_public_path__ + "static/media/modal-close-icon.a04b8de8.svg";